export class SetPasswordRequest {
	public linkCode: string;
	public password: string;
}
